import {
  CONFIG_FETCH,
  CONFIG_UPDATE
} from '../constants/ActionTypes';
import DbWsAction from './models/DbWsAction';

const action = new DbWsAction(
  CONFIG_FETCH,
  CONFIG_UPDATE
);

export const fetch = action.fetch;
export const update = action.update;

